<template>
  <div class="mb-10">
    <AppOnOffToggle v-model="includeArchived">
      {{ labelText }}
    </AppOnOffToggle>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getProjectFlavourLabel } from '~/utils/project_flavour';

export default {
  name: 'ReportIncludeArchivedToggle',
  props: {
    label: { type: String },
  },
  computed: {
    ...mapState(['organization']),
    includeArchived: {
      get() {
        return this.$store.getters.includeArchived;
      },
      set(newValue) {
        this.$store.dispatch('updateSearch', { include_archived: newValue });
      },
    },
    defaultLabel() {
      const label = getProjectFlavourLabel(this.organization.project_flavour, true);

      return `Include archived ${label.toLowerCase()}`;
    },
    labelText() {
      return this.label || this.defaultLabel;
    },
  },
};
</script>
